export const setApprove = (state, payload) => state.isApproved = payload;
export const setCredential = (state, payload) => state.credential = payload;
export const setFilesOfCredential = (state, payload) => state.credential.files = payload;
export const setTotalFail = (state, payload) => state.totalFail = payload;
export const setIsUploadedFile = (state, payload) => state.credential.is_uploaded_file = payload;
